export default __webpack_public_path__ + "static/media/2016.3a612188.png";